import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { normalize, schema } from 'normalizr';
import { loadWaitingList, exportWaitingList } from './actions';
import Filter from './Filter';
import List from './List';
import authUtils from '../../auth/utils';
import { loadUnpagedGrades } from '../grades/actions';
import SendMessageButton from '../../common/components/message/SendMessageButton';
import {
	sendMessage,
	PARENT_SEND_MESSAGE_REQUEST, PARENT_SEND_MESSAGE_SUCCESS, PARENT_SEND_MESSAGE_FAILURE
} from '../parents/actions';

class WaitingList extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleListSelectionChange = this.handleListSelectionChange.bind(this);
		this.handleSendMessage = this.handleSendMessage.bind(this);
		this.state = {
			selectedEntities: []
		};
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		this.loadGrades();
	
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({...filter, sortKey, sortDirection, pageSize, pageNumber});
	}

	handleFilterSubmit(filter, isExport) {
		const { sortKey, sortDirection, pageSize } = this.props.pagination;
		this.setState({ selectedEntities: [] });
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
		if (isExport)
			this.exportData(filter);
	}

	exportData(filter) {
		this.props.exportWaitingList(filter);
	}

	handleFilterReset() {
		this.handleFilterSubmit({});
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}
		
	reloadData() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;		
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
	}

	loadGrades() {
		const { loadUnpagedGrades } = this.props;
		loadUnpagedGrades();
	}

	handleListSelectionChange(newSelectedEntities) {
		this.setState({ selectedEntities: newSelectedEntities });
	}

	handleSendMessage(values, onSuccess) {
		const { sendMessage } = this.props;
		sendMessage({ ...values, parentIds: this.selectedParentIds() }, onSuccess);
	}

	selectedParentIds() {
		return [...new Set(this.state.selectedEntities.map(item => item.parent.id))]
	}
	normalizeData(waitingLists) {
		const parent = new schema.Entity('parents', {}, {
			idAttribute: c => c.id
		});
		const item = new schema.Entity('waitingLists', { parent: parent }, {
			idAttribute: p => p.id
		});
		const normalizedData = normalize(waitingLists, [item]);
		return normalizedData;
	}

	renderListActions() {
		const { canSendMessage, t } = this.props;

		const normalizedData = this.normalizeData(this.state.selectedEntities);
		const parents = normalizedData && normalizedData.entities && normalizedData.entities.parents;

		return <React.Fragment>
			{canSendMessage && <SendMessageButton onSendMessage={this.handleSendMessage} to={parents && Object.values(parents).map(p => ({ name: p.name, email: p.email }))}
				block={PARENT_SEND_MESSAGE_REQUEST} unblock={[PARENT_SEND_MESSAGE_SUCCESS, PARENT_SEND_MESSAGE_FAILURE]} />}
		</React.Fragment>
	}

	render() {
		const { isReadonly, grades, waitingListStatusTypes, canSendMessage } = this.props;
		return (
			<div>
				<Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} grades={grades} waitingListStatusTypes={waitingListStatusTypes} loading={this.props.pagination.loading || this.props.export.loading} />
				<List isReadonly={isReadonly} onFetchData={this.handleListEvent} data={this.props.data}
					selectedEntities={this.state.selectedEntities} onSelectionChange={this.handleListSelectionChange}
					listActions={this.renderListActions()} canSendMessage={canSendMessage}
					{...this.props.pagination} />
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		exports,
		entities: { waitingLists, grades },
		lookups: {waitingListStatusTypes },
		auth: { currentUser },
		configuration: { franchisor }
	} = state;

	const waitingListsPagination = pagination.waitingLists.all || { ids: [], pageNumber: 1, pageSize: 10 };
	const waitingListExport = exports.waitingList.all || {};

	return {
		data: waitingListsPagination.ids.map(id => waitingLists[id]),
		pagination:  waitingListsPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'WaitingList'),
		waitingListStatusTypes,
		grades,
		canSendMessage: franchisor.enableAdHocMessages && authUtils.hasPermission(currentUser, 'SendMessage'),
		export: waitingListExport
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadWaitingList,
	loadUnpagedGrades,
	exportWaitingList,
	sendMessage,
	initializeFilter: (data, fields) => initialize('waitingListFilter', data, fields)
})(WaitingList);